// Chequeo de licencia contra Tollkeep. Reutilizable en el login de cualquier app.
// La app solo pregunta "¿esta empresa/tenant tiene licencia al día?"; el cobro vive 100% en Tollkeep.

// Credenciales en .env.local (ver .env.example). Vue CLI solo expone variables VUE_APP_*.
const TOLLKEEP = {
  url: process.env.VUE_APP_TOLLKEEP_URL,
  platform: process.env.VUE_APP_TOLLKEEP_PLATFORM, // "ERP Colombia Vue 2.0" en Tollkeep
  key: process.env.VUE_APP_TOLLKEEP_KEY,
};

if (!TOLLKEEP.url || !TOLLKEEP.platform || !TOLLKEEP.key) {
  console.warn("Tollkeep: faltan variables VUE_APP_TOLLKEEP_* en .env.local; el chequeo de licencia hará fail-open.");
}

/**
 * Se envía tal cual lo que el usuario escribe en el login: Tollkeep no interpreta
 * el formato (números, letras, lo que sea), solo busca qué licencia cubre ese id.
 * Devuelve el veredicto: { allowed, status, message, payment_url?, covered_count? }.
 */
export async function checkLicense(storeCode) {
  const external_company_id = String(storeCode || "").trim();
  try {
    const res = await fetch(TOLLKEEP.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Platform-Key": TOLLKEEP.key,
      },
      body: JSON.stringify({ platform: TOLLKEEP.platform, external_company_id }),
    });
    return await res.json();
  } catch (e) {
    // fail-open: si Tollkeep no responde, no bloqueamos el login (continuidad del negocio).
    console.warn("Tollkeep: license check falló, se deja pasar:", e);
    return { allowed: true, _error: String(e) };
  }
}
